import { React, useState } from "react";
import classes from './PhaseNav.module.scss'

//MUI Imports
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

function PhaseNav({phases, phaseIndex, onPhaseSelect}) {
    
    const [value, setValue] = useState(0);
    // let currentPath = useLocation();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box className={`content_wrapper__inner ${classes.PhaseNav}`}> 
            <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                className={`${classes.PhaseNav__tabs}`}
                sx={{
                    '.MuiTabs-indicator': {
                      backgroundColor:"#ffffff"
                    },
                    '.Mui-selected':{
                        color:"#ffffff !important"
                    }
                  }}
            > 
                {phases.map((element, index) => {
                    return(

                        <Tab 
                            key={index}
                            className={(phaseIndex === index ? "chosen" : "")}
                            value={index} 
                            label={element.name}
                            onClick={() => {onPhaseSelect(index)}}
                            sx={
                                {
                                    color:"#ffffff",
                                    fontSize:"16px",
                                    padding:"0 40px",
                                }
                            }
                        />     
                    )
                })}
            </Tabs>
        </Box>
    )
                            

}
export default PhaseNav